import { useRef } from 'react';

export function useInitRef<T extends {}>(init: () => T) {
  const ref = useRef(null as any as T);

  if (ref.current === null) {
    ref.current = init();
  }

  return ref;
}
